// Some browsers (e.g. Firefox) include leading/trailing whitespace from text nodes (e.g. " EID " in table cells)
// in the copied selection. Trim the copied text for single-line selections.
export function installCopyTrim(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.addEventListener('copy', (event: ClipboardEvent) => {
    const target = event.target as HTMLElement | null;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
      return;
    }

    const selection = window.getSelection();
    const text = selection?.toString();
    if (!text || /[\r\n\t]/.test(text) || text === text.trim()) {
      return;
    }

    event.clipboardData?.setData('text/plain', text.trim());
    event.preventDefault();
  });
}
